module.exports = __webpack_public_path__ + "static/img/baii_t.46f56ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baii_t.png
// module id = 9nau
// module chunks = 1